module.exports = __webpack_public_path__ + "img/filter-slash.dab12be9.svg";